import classNames from "classnames";
import { useMemo } from "react";

type Props = {
  progress: number;
  maxProgress?: number; // just in case we want to limit something
  duration?: 75 | 100 | 150 | 200 | 300 | 500 | 700 | 1000;
  className?: string;
  barColor?: string;
  backgroundColor?: string;
};

export const ProgressBar = ({
  progress,
  maxProgress = 100,
  duration = 150,
  className = "",
  barColor = "bg-secondary-500",
  backgroundColor = "bg-other-light-200",
}: Props) => {
  const maxProgressToUse = useMemo(
    () => Math.min(100, Math.max(0, maxProgress)),
    [maxProgress]
  );

  const progressToUse = useMemo(
    () => Math.min(maxProgressToUse, Math.max(0, progress)),
    [progress, maxProgressToUse]
  );

  return (
    <div className={className}>
      <div className={classNames("h-3 w-full rounded-full", backgroundColor)}>
        <div
          className={classNames(
            `h-3 rounded-full transition-all duration-${duration}`,
            barColor
          )}
          style={{ width: `${progressToUse}%` }}
        />
      </div>
    </div>
  );
};
